import React, {Component} from 'react';
import '../../../css/pages/admin/Admin.css'
import {NavLink, Redirect, Route, Switch} from "react-router-dom";
import Menu from "../../components/Menu";
import UserAccounts from "../admin/UserAccounts";
import GuestbookPending from "../admin/GuestbookPending";
import RoomRatesEditor from "../admin/RoomRatesEditor";
import AdminCalendar from "../admin/AdminCalendar";
import AdminLogin from "./AdminLogin";
import BookingRequests from "../../../css/pages/admin/components/BookingRequests";

class Admin extends Component {

    admin_menu = [
        {
            title: "User Accounts",
            url: "/admin/accounts",
            sublinks: []
        },
        {
            title: "Guestbook",
            url: "/admin/guestbook",
            sublinks: []
        },
        {
            title: "Room Rates",
            url: "/admin/rates",
            sublinks: []
        },
        {
            title: "Calendar",
            url: "/admin/calendar",
            sublinks: []
        },
        {
            title: "Booking Requests",
            url: "/admin/requests",
            sublinks: []
        },
    ];

    constructor(props) {
        super(props);

        this.state = {
            token: ""
        };
    }

    login = (token, redirect) => {
        console.log("Token acquired from server (length: " + token.length + ")");
        this.setState({
            token: token
        });

        return <Redirect to={redirect || "/admin/calendar"}/>
    };

    render() {
        return (
            <div id={"admin_wrapper"}>
                <div id={"header_wrapper"}>
                    {this.state.token && <Menu id={"admin_menu"} links={this.admin_menu}/>}
                </div>
                <div id={"admin_content"}>
                    <NavLink to={"/"} className={"small_info"} style={{display: "block"}}>
                        Click here to return home for Bookings and Riad information.
                    </NavLink>

                    {
                        this.state.token ?
                            <Switch>
                                <Route path={"/admin/accounts"}
                                       render={() => <UserAccounts token={this.state.token}/>}/>
                                <Route path={"/admin/guestbook"}
                                       render={() => <GuestbookPending token={this.state.token}/>}/>
                                <Route path={"/admin/rates"}
                                       render={() => <RoomRatesEditor token={this.state.token}/>}/>
                                <Route path={"/admin/calendar"}
                                       render={() => <AdminCalendar token={this.state.token}/>}/>
                                <Route path={"/admin/requests"}
                                       render={() => <BookingRequests token={this.state.token}/>}/>
                                <Redirect to={"/admin/requests"}/>
                            </Switch> :
                            <AdminLogin loginCallback={this.login} redirect={this.props.location}/>
                    }

                </div>
            </div>
        )
    }

}

export default Admin